//@flow
import React from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css' // optional
import './styles.scss'

export class Celllinie extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {

    }
    this.generateList = this.updateSizes.bind(this)
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {

    //prepare list of ddeparture times
    const departs = this.props.departs.split(',')
    const list = departs.map(function (item, index) {
      return '<li>XXh'+item+'</li>'
    }).join('')

    const tipTitle = '<h3>'+this.props.linie+' en direction de '+this.props.end+'</h3>'
    const tipDeparts = '<div >Heures de départ de '+this.props.start+':</div>'+'<ul>'+list+'</ul>'
    const tipDuration = '<p>Durée: '+this.props.duration+' min</p>'
    const tipHint = "<p>Depuis l'entrée en vigueur du nouvel horaire CFF, fin 2022, plusieurs lignes du RER vaudois ont été renumérotées. La S2 s'appelle désormais S4 et la S5 s'appelle désormais S3.</p>"

    const tipContent = this.state.isMobile ?
      (this.props.linie === 'S2' || this.props.linie === 'S5') ?
        tipTitle+tipDeparts+tipDuration+tipHint
      :
        tipTitle+tipDeparts+tipDuration
    :
    (this.props.linie === 'S2' || this.props.linie === 'S5') ?
        tipTitle+tipDeparts+tipHint
      :
        tipTitle+tipDeparts

    return <div className='celllinie'>
            <Tippy
              content={<div dangerouslySetInnerHTML={{__html:tipContent}} />}
              className='tooltip'
              trigger={this.state.isMobile ? 'click' : 'mouseenter'}
              placement={'bottom'}
              offset={[0, 8]}
              theme={this.props.colorMode}
              interactive={true}>
              <span>{this.props.linie}</span>
            </Tippy>
          </div>
  }
}



             